import { render, staticRenderFns } from "./Case713.vue?vue&type=template&id=b8b1cf5a&scoped=true&"
import script from "./Case713.vue?vue&type=script&lang=js&"
export * from "./Case713.vue?vue&type=script&lang=js&"
import style0 from "./Case713.vue?vue&type=style&index=0&id=b8b1cf5a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b1cf5a",
  null
  
)

export default component.exports